import { TypedSearchResultDataValue } from "./utils";
import TimedSearchResult from "./timed-search-result/TimedSearchResult";
import SimpleSearchResult from "./simple-search-result/SimpleSearchResult";
import TagSearchResult from "./tag-search-result/TagSearchResult";

export const getComponent = (
    item: TypedSearchResultDataValue,
    key: string,
    mediaUrl: string,
    baseClassName: string
) => {
    switch (item.type) {
        case "tags":
            return <TagSearchResult data={item} masterKey={key} key={key} />;
        case "caption":
            return <TimedSearchResult data={item} key={key} mediaUrl={mediaUrl} baseClassName={baseClassName} />;
        case "slides":
            return <TimedSearchResult data={item} key={key} mediaUrl={mediaUrl} baseClassName={baseClassName} />;
        case "chapters":
            return <TimedSearchResult data={item} key={key} mediaUrl={mediaUrl} baseClassName={baseClassName} />;
        case "comments":
            if (item.startTime !== 0) {
                // timed comment
                return <TimedSearchResult data={item} key={key} mediaUrl={mediaUrl} baseClassName={baseClassName} />;
            }
            return <SimpleSearchResult data={item} key={key} />;
        case "quiz":
            return <TimedSearchResult data={item} key={key} mediaUrl={mediaUrl} baseClassName={baseClassName} />;
        case "polls":
            return <TimedSearchResult data={item} key={key} mediaUrl={mediaUrl} baseClassName={baseClassName} />;
        case "metadata":
            return <SimpleSearchResult data={item} key={key} />;
        case "ocr":
            return <TimedSearchResult data={item} key={key} mediaUrl={mediaUrl} baseClassName={baseClassName} />;
        default:
            console.log("search results unhandled data item", item.type);
            return <div key={key} />;
    }
};
